import {
  USER_INVITATION_FORM_FIELD_NAME_MESSAGE,
  USER_INVITATION_FORM_FIELD_NAME_SUBJECT,
} from '../../../User'

export function getUserInvitationFormInitialValues({ message, subject }) {
  return {
    [USER_INVITATION_FORM_FIELD_NAME_MESSAGE]: message,
    [USER_INVITATION_FORM_FIELD_NAME_SUBJECT]: subject,
  }
}
